import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/odd molly - white dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Golden Porcelain",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/odd molly - white dress.jpeg",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Golden Porcelain",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/odd molly - white dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Golden Porcelain",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/odd molly - red dress.jpeg",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dusted Rouge",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/odd molly - red dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dusted Rouge",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/odd molly - red dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dusted Rouge",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/odd molly - blue dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stormy Blue",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/odd molly - blue dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stormy Blue",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/odd molly - blue dress.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Stormy Blue",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/odd molly - white jeans.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Offchalk",
                        },
                        {
                            type: "Size",
                            value: "34",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/odd molly - blue jeans.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue",
                        },
                        {
                            type: "Size",
                            value: "36",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/odd molly - blue jeans.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue",
                        },
                        {
                            type: "Size",
                            value: "34",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/odd molly - white jeans.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Offchalk",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/odd molly - white jeans.jpeg",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Offchalk",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/odd molly - blue jeans.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/odd molly - blue jeans.jpeg",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Blue",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Signe Dress",
                imageSrc: "/mocks/odd molly - white dress.jpeg",
                imageAlt: "/mocks/odd molly - white dress.jpeg",
                quantity: 1,
                purchasePrice: 1995,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Porcelain",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Colette Pants",
                imageSrc: "/mocks/odd molly - white jeans.jpeg",
                imageAlt: "/mocks/odd molly - white jeans.jpeg",
                quantity: 1,
                purchasePrice: 1795,
                properties: [
                    {
                        type: "Size",
                        value: "36",
                    },
                    {
                        type: "Color",
                        value: "Offchalk",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 40,
                sessionItemId: 3,
                productName: "Elizabeth Vest",
                imageSrc: "/mocks/odd molly - vest black.jpeg",
                imageAlt: "/mocks/odd molly - vest black.jpeg",
                quantity: 1,
                purchasePrice: 1995,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
